module.exports = __webpack_public_path__ + "static/preview-citzbooking-1861c9e9bf3dceb311c4b05269644217.png";